import { defaultTheme, PaginationTheme } from '@medly-components/theme';

import colors from './colors';

export const pagination: PaginationTheme = {
    ...defaultTheme.pagination,
    fontVariant: 'body2',
    pageNumber: {
        ...defaultTheme.pagination.pageNumber,
        color: {
            ...defaultTheme.pagination.pageNumber.color,
            default: colors.darkBlue,
            active: colors.darkBlue
        },
        bgColor: {
            ...defaultTheme.pagination.pageNumber.bgColor,
            active: colors.coral[500]
        },
        fontWeight: {
            default: 'Medium',
            selected: 'Medium'
        }
    },
    pageNav: {
        ...defaultTheme.pagination.pageNav,
        color: {
            ...defaultTheme.pagination.pageNav.color,
            default: colors.darkBlue
        }
    },
    overlayPageNumber: {
        ...defaultTheme.pagination.overlayPageNumber,
        color: {
            ...defaultTheme.pagination.overlayPageNumber.color,
            default: colors.red[500]
        }
    }
};
